import { render, staticRenderFns } from "./ReturnTransactions.vue?vue&type=template&id=2473f466&"
import script from "./ReturnTransactions.vue?vue&type=script&lang=js&"
export * from "./ReturnTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports